<template>
    <div>
        <el-dialog title="APP版本更新信息设置" :visible="showVisible" @close="closeDialog()" width="1400px">

            <div style="border:1px solid #dcdfe6;padding-top: 20px;">
                <el-form ref="infoForm" :model="info" :rules="rules" label-width="200px">
                    <el-form-item label="APP类型：" prop="type">
                        <el-select v-model="info.type" @change="setUrl">
                            <el-option v-for="item in appTypes" :key="item" :value="item" :label="item"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="最新版本号：">
                        {{info.type === 'Android' ? androidVersion : info.type === 'iPhone' ? iosVersion : ''}}
                    </el-form-item>
                    <el-form-item label="升级版本号：" prop="version">
                        <el-input v-model="info.version"></el-input>
                    </el-form-item>
                    <el-form-item label="更新信息（中文）：" prop="updateInfoZh">
                        <el-input v-model="info.updateInfoZh" type="textarea"></el-input>
                    </el-form-item>
                    <el-form-item label="更新信息（英文）：" prop="updateInfoEn">
                        <el-input v-model="info.updateInfoEn" type="textarea"></el-input>
                    </el-form-item>
                    <el-form-item label="是否强制更新：">
                        <el-select v-model="info.updateForce">
                            <el-option v-for="item in options" :key="item.value" :label="item.label"
                                       :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="安装包路径：">
                        <el-input v-model="info.url"></el-input>
                    </el-form-item>
                    <el-form-item v-if="info.type === 'Android'">
                        <el-upload ref="upload" :http-request="handleReq" action="/admin/upload/app/package"
                                   :headers="{ 'Authorization': token }" :data="{platform: 'android'}"
                                   :show-file-list="false" :on-success="handleSuccess">
                            <el-button size="small" type="primary" :loading="uploadLoading">选择安装包上传</el-button>
                        </el-upload>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="info" @click="closeDialog()">取消</el-button>
                        <el-button type="primary" @click="submitInfo()">提交</el-button>
                    </el-form-item>
                </el-form>
                <br><br>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import userInfoHelper from '../../../../common/userInfo';
    import {mapActions, mapState} from 'vuex';
    import axios from 'axios';

    export default {
        name: "updateEdit",
        props: ['showVisible', 'opType'],

        data() {
            return {
                token: userInfoHelper.get().accessToken,
                appTypes: ['Android', 'iPhone'],
                info: {
                    id: '',
                    type: '',
                    version: '',
                    updateInfoZh: '',
                    updateInfoEn: '',
                    updateForce: 0,
                    url: ''
                },
                rules: {
                    version: [{required: true, message: '版本号不能为空！', trigger: 'blur'}],
                    updateInfoZh: [{required: true, message: '中文内容不能为空！', trigger: 'blur'}],
                    contentEn: [{required: true, message: '英文内容不能为空！', trigger: 'blur'}],
                    type: [{required: true, message: 'APP类型不能为空！', trigger: 'blur'}],
                },
                options: [{value: 0, label: '否'}, {value: 1, label: '是'}],
                androidVersion: '',
                iosVersion: '',
                uploadLoading: false,
            }
        },

        computed: {
            ...mapState('app', ['updateInfo'])
        },

        methods: {
            ...mapActions('app', ['update', 'getNewestVersion', 'buildUpdateInfo']),
            handleReq(data) {
                if (this.uploadLoading) return;
                this.uploadLoading = true;
                let _data = new FormData();
                _data.append('file', data.file);
                _data.append('platform', 'android');
                axios.request({
                    method: 'POST',
                    url: data.action,
                    headers: {
                        Authorization: userInfoHelper.get().accessToken,
                        Username: userInfoHelper.get().userName,
                        'content-type': 'multipart/form-data'
                    },
                    data: _data,
                    timeout: 600000
                })
                    .then((data) => {
                        if (!data.data.code && data.data.data) {
                            this.info.url = data.data.data;
                            this.$message({
                                showClose: true,
                                message: '上传成功',
                                type: 'success'
                            });
                        }
                    })
                    .catch(() => {
                    })
                    .finally(() => {
                        this.uploadLoading = false;
                    });
            },
            closeDialog() {
                this.info = {};
                this.buildUpdateInfo({});
                this.$emit('close');
            },

            submitInfo() {
                this.$refs['infoForm'].validate(valid => {
                    if (valid) {
                        if (this.info.type === 'Android' && !this.info.url) {
                            this.$message('请上传Android包');
                            return;
                        }
                        this.update(this.info).then(() => {
                            this.$message.success('操作成功');
                            this.closeDialog();
                        })
                    }
                })
            },

            handleSuccess(response) {
                this.info.url = response.data;
                this.$message('上传成功');
            },

            submitUpload() {
                this.$refs.upload.submit();
            },

            /**初始化最新版本号*/
            initNewestVersion() {
                this.getNewestVersion().then(response => {
                    this.iosVersion = response.data.iosVersion;
                    this.androidVersion = response.data.androidVersion;
                })
            },
            setUrl(value) {
                if (value == "Android") {
                    this.info.url = "";
                } else {
                    this.info.url = "";
                }
            }
        },

        watch: {
            'showVisible': function () {
                if (this.showVisible === true) {
                    this.initNewestVersion();
                }
                if (this.opType === 'update') {
                    let info = {}
                    info.id = this.updateInfo.id;
                    info.type = this.updateInfo.type;
                    info.version = this.updateInfo.version;
                    info.updateForce = this.updateInfo.force;
                    info.updateInfoZh = this.updateInfo.contentZh;
                    info.updateInfoEn = this.updateInfo.contentEn;
                    info.url = this.updateInfo.url;
                    this.info = info
                }
            }
        }

    }
</script>

<style scoped>

</style>